module.exports = __webpack_public_path__ + "img/icon_consignment.578ef75.webp";